module.exports = __webpack_public_path__ + "static/img/quanbuzhibo.a10d352.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/quanbuzhibo.png
// module id = 0FRY
// module chunks = 1